import React from "react";
import { Box } from "@mui/material";
import Table, { SortDir } from "../../deprecatedUikit/Table/Table";
import { FormattedInvoiceItem } from "../formatSubscriptions";

const headerCells = [
    {
      id: 'invoiceNumber',
      label: 'Invoice Number'
    },
    {
      id: 'type',
      label: 'Type'
    },
    {
      id: 'amount',
      label: 'Amount'
    },
    {
      id: 'serviceMonth',
      label: 'Service Month'
    },
    {
      id: 'paymentDate',
      label: 'Payment Date'
    },
    {
      id: 'status',
      label: 'Status'
    }
  ];

interface PartnerSubscriptionInvoicesTableProps {
    transactions: FormattedInvoiceItem[];
    handleSortChange: (property: string, order: SortDir) => void;
}

const PartnerSubscriptionInvoicesTable = ({transactions, handleSortChange}: PartnerSubscriptionInvoicesTableProps) => {

    return <Box mt={4}>
        <Table
            headCells={headerCells}
            rows={transactions}
            actionType='button'
            isSortable
            handleSortRequest={handleSortChange}
        />
    </Box>
}

export default PartnerSubscriptionInvoicesTable;